import React from "react"
import { Link } from "react-router-dom"

// Import menuDropdown
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"

import logoLight from "../../assets/images/logo-light.png"
import logoLightSvg from "../../assets/images/logo-light.svg"

import newStore from "../../newStore"

const Header = ({ toggleLeftmen }) => {
  const { logo } = newStore()

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm ms-1">
                  {logo?.sm ? (
                    <img
                      src={`data:image/jpeg;base64,${logo.sm}`}
                      alt=""
                      height="59"
                    />
                  ) : (
                    <img src={logoLightSvg} alt="" height="22" />
                  )}
                </span>
                <span className="logo-lg">
                  {logo?.lg ? (
                    <img
                      src={`data:image/jpeg;base64,${logo.lg}`}
                      alt=""
                      height="50"
                    />
                  ) : (
                    <img src={logoLight} alt="" height="19" />
                  )}
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  {logo?.sm ? (
                    <img
                      src={`data:image/jpeg;base64,${logo.sm}`}
                      alt=""
                      height="22"
                    />
                  ) : (
                    <img src={logoLightSvg} alt="" height="22" />
                  )}
                </span>
                <span className="logo-lg">
                  {logo?.lg ? (
                    <img
                      src={`data:image/jpeg;base64,${logo.lg}`}
                      alt=""
                      height="19"
                    />
                  ) : (
                    <img src={logoLight} alt="" height="19" />
                  )}
                </span>
              </Link>
            </div>

            <div className="d-flex align-items-center">
              <button
                type="button"
                className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
                data-toggle="collapse"
                onClick={toggleLeftmen}
                data-target="#topnav-menu-content"
              >
                <i className="fa fa-fw fa-bars" />
              </button>
            </div>
          </div>
          <ProfileMenu />
        </div>
      </header>
    </React.Fragment>
  )
}

export default Header
